import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { subscribeLoadProgress } from "@/lib/loadProgress";

export const DataLoadBar = () => {
  const { pathname } = useLocation();
  const [p, setP] = useState({ total: 0, done: 0 });
  useEffect(() => subscribeLoadProgress(setP), []);
  if (!pathname.startsWith("/kpi")) return null;
  const active = p.total > 0 && p.done < p.total;
  const pct = p.total ? Math.round((p.done / p.total) * 100) : 100;
  return (
    <div data-testid="kpi-load-bar" aria-hidden={!active}
      className={`fixed inset-x-0 top-0 z-[80] transition-opacity duration-300 ${active ? "opacity-100" : "opacity-0 pointer-events-none"}`}>
      <div className="h-1 w-full bg-slate-200/70">
        <div data-testid="kpi-load-bar-fill" className="h-full bg-blue-600 transition-[width] duration-200 ease-out" style={{ width: `${pct}%` }} />
      </div>
      <div className="flex justify-center">
        <span data-testid="kpi-load-bar-label" className="inline-flex items-center gap-1.5 rounded-b-md bg-slate-900 px-2.5 py-1 text-[11px] font-medium text-white shadow-md">
          <span className="h-1.5 w-1.5 rounded-full bg-blue-400 animate-pulse" />
          Chargement des données… {pct}% ({p.done}/{p.total})
        </span>
      </div>
    </div>
  );
};
